import { rgba } from 'polished'
import styled, { css } from 'styled-components'
import { theme } from '~/styles'

export interface InputWrapperProps {
  errors?: boolean
  disabled?: boolean
  active?: boolean
  error?: boolean | string
  direction?: string
  icon?: string
  iconPosition?: string
}

export const InputWrapper = styled.input<InputWrapperProps>`
  ${props => css`
    padding: 8px 16px;
    font-size: 14px;
    font-family: 'Inter', sans-serif;
    color: ${props => props.theme.colors.color2d3139};
    transition: all 0.2s ease-in-out;
    border-radius: ${({ theme }) => theme.zds.border.radius100};
    width: 100%;
    outline: none;
    height: 40px;
    border: 1px solid ${theme.colors.colore9ecf3};
    padding-left: ${props.icon && props.iconPosition === 'left' ? '44px' : ''};
    padding-right: ${props.icon && props.iconPosition === 'right' ? '44px' : ''};

    ::-webkit-outer-spin-button,
    ::-webkit-inner-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
    ::-webkit-calendar-picker-indicator {
      filter: invert(60%);
    }
    ::-webkit-datetime-edit-fields-wrapper {
      font-family: 'Inter', sans-serif;
    }
    ${props.errors &&
    css`
      border: 1px solid ${theme.colors.colorFF2424};
    `}
    ${!props.errors &&
    props.active &&
    css`
      border: 1px solid ${theme.colors.color378ff7};
    `}

  ${props.disabled &&
    css`
      background: ${props.theme.colors.colore9ecf3};
      border: 1px solid ${props.theme.colors.colord4d9de};
      pointer-events: none;
    `}

  &::placeholder {
      color: ${theme.colors.color6b7786};
      opacity: 0.5;
    }

    &::-ms-input-placeholder {
      color: ${theme.colors.color6b7786};
      opacity: 0.5;
    }

    &::-ms-input-placeholder {
      color: ${theme.colors.color6b7786};
      opacity: 0.5;
    }
  `}
`

interface InputContainer {
  margin?: string
}

export const InputContainer = styled.div<InputContainer>`
  display: flex;
  flex-direction: column;
  width: 100%;
  flex: 1;
  margin: ${({ margin }) => margin};
  border-radius: 4px;
  position: relative;
  color: ${theme.colors.color6b7786};
  input::-webkit-calendar-picker-indicator {
    cursor: pointer;
  }
`

export const Text = styled.p`
  margin: 0px 5px;
  font-size: 14px;
`

const stateInput = {
  error: css`
    color: ${theme.colors.color6b7786};

    svg {
      fill: ${theme.colors.colorFF2424};
    }
  `,
  active: css`
    -webkit-box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
    -moz-box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
    box-shadow: 0px 0px 6px 0px ${rgba(theme.colors.color378ff7, 0.4)};
  `
}

export const WrapperLight = styled.div<InputWrapperProps>`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: ${props => props.direction};
  align-items: center;
  border-radius: ${({ theme }) => theme.zds.border.radius100};

  svg {
    fill: transparent;
    position: absolute;
    right: ${props => (props.iconPosition === 'right' ? '14px' : null)};
    left: ${props => (props.iconPosition === 'left' ? '14px' : null)};
  }
  ${({ active }) => (active ? stateInput.active : null)};
  ${({ error }) => (error ? stateInput.error : null)}
`

export const ErrorContainer = styled.span`
  color: ${theme.colors.colorFF2424};
  font-size: 12px;
  padding-top: 4px;
  position: absolute;
  top: 100%;
`

export const IconContainer = styled.div<{
  margin?: string | undefined
  iconsize?: string | number
}>`
  margin: ${props => props.margin ?? 'unset'};
  display: flex;
  justify-content: center;
  align-items: center;

  cursor: pointer;

  svg {
    width: 20px;
  }
`
